/* @flow */
import * as React from 'react';
import Text from 'components/Text';
import Image from 'components/Image';

import './styles/IntegrationWizardHeaderContent.scss';

type Props = {
  title: string,
  iconURL: string,
  cta?: React.Node,
};

class IntegrationWizardHeaderContent extends React.Component<Props, {}> {
  render() {
    console.log(this.props);

    return (
      <div className="IntegrationWizardHeaderContent">
        <div className="IntegrationWizardHeaderContent-name">
          <div className="IntegrationWizardHeaderContent-name-logo">
            <Image src={this.props.iconURL} />
          </div>
          <div>
            <Text size="large">{this.props.title}</Text>
          </div>
        </div>
        {this.props.cta && (
          <div className="IntegrationWizardHeaderContent-buttons">{this.props.cta}</div>
        )}
      </div>
    );
  }
}

export default IntegrationWizardHeaderContent;
